import { render, staticRenderFns } from "./FoundPatientSelector.vue?vue&type=template&id=38ea7efe&scoped=true&"
import script from "./FoundPatientSelector.vue?vue&type=script&lang=ts&"
export * from "./FoundPatientSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FoundPatientSelector.vue?vue&type=style&index=0&id=38ea7efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea7efe",
  null
  
)

export default component.exports